// How old a meter reading is, for the "Reading at ..." line on the live
// reading tiles. Pure, so it can be tested on its own.

// A reading older than this no longer counts as live.
export const STALE_AFTER_MINUTES = 30;

// { text, stale } for a reading taken at `ts` (ms), as seen at `now` (ms).
// `text` is "just now", "5 min ago", "3 h ago" or "2 days ago".
export const readingAge = (ts, now = Date.now()) => {
  const minutes = Math.max(0, Math.floor((now - ts) / 60000));
  const stale = minutes > STALE_AFTER_MINUTES;
  if (minutes < 1) return { text: "just now", stale };
  if (minutes < 60) return { text: `${minutes} min ago`, stale };
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return { text: `${hours} h ago`, stale };
  const days = Math.floor(hours / 24);
  return { text: `${days} ${days === 1 ? "day" : "days"} ago`, stale };
};
